import postWorkflowTask from './fetch/postWorkflowTask';
import postWorkflowCancelTask from './fetch/postWorkflowCancelTask';

export default class SaveWorkflowService {
    leadId: string | undefined = '';

    constructor(leadId: string | undefined) {
        this.leadId = leadId;
    }

    send({ task, payload }: any, token: string): Promise<any> {
        let _t = { ...payload };

        if (_t.leasmanCustomerId) {
            _t.leasmanCustomerId = Number(_t.leasmanCustomerId);
        }
        if (_t.leasmanMasterContractId) {
            _t.leasmanMasterContractId = Number(_t.leasmanMasterContractId);
        }

        if (this.leadId)
            return postWorkflowTask(
                this.leadId,
                {
                    task: task,
                    parameters: _t,
                },
                token
            );
        else return Promise.reject();
    }

    cancel(token: string): Promise<any> {
        if (this.leadId)
            return postWorkflowCancelTask(
                this.leadId,
                {
                    reason: 'Manual cancel',
                },
                token
            );
        else return Promise.reject();
    }
}
